import React from "react";
import { GridLegacy as Grid, Typography } from "@mui/material";
import { makeStyles } from "@/compat/muiStyles";
import FormQuestion from "../../../components/formcompleter/FormQuestion";

const useStyles = makeStyles((theme) => ({
    questions: {
        width: '100%',
    },
    questionContainer: {
        marginBottom: theme.spacing(3),
    },
    sectionTitle: {
        color: '#1c1b1f',
        fontWeight: 600,
        fontSize: '16px',
        marginBottom: theme.spacing(2),
        fontFamily: 'Inter, sans-serif'
    }
}));

interface NonUserFormSectionProps {
    section: any;
    value?: any;
}

const NonUserFormSection = ({ section }: NonUserFormSectionProps) => {
    const classes = useStyles();

    return (
        <div className={classes.questions}>
            <Typography className={classes.sectionTitle}>
                {section.name}
            </Typography>
            <Grid container spacing={2}>
                {section.questions.map((question) => (
                    <Grid
                        item
                        key={question.id}
                        xs={12}
                        className={classes.questionContainer}
                    >
                        <FormQuestion question={question} />
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};

export default NonUserFormSection; 